import React, { useEffect, useState } from 'react';
import axios from 'axios';

function SubirUsuariosFinales() {
  const [clients, setClients] = useState([]);
  const [selectedClient, setSelectedClient] = useState('');
  const [excelFile, setExcelFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_URL}admin/get_clients.php`);
        setClients(response.data?.clients || []);
      } catch (error) {
        setClients([]);
        setMessage('No se pudieron cargar los clientes');
      }
    };

    fetchClients();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedClient) {
      setMessage('Selecciona un cliente');
      return;
    }

    if (!excelFile) {
      setMessage('Selecciona un archivo Excel');
      return;
    }

    setIsUploading(true);
    setMessage('Subiendo archivo...');

    try {
      const formData = new FormData();
      formData.append('cliente', selectedClient);
      formData.append('file', excelFile);

      const response = await axios.post(
        `${process.env.REACT_APP_URL}admin/subir_usuarios_finales.php`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data?.success) {
        setMessage(
          `Carga finalizada. Insertados: ${response.data.inserted || 0}, Omitidos: ${response.data.skipped || 0}, Correos inválidos: ${response.data.invalidEmails || 0}, Correos duplicados: ${response.data.duplicatedEmails || 0}`
        );
      } else {
        setMessage(response.data?.message || 'Error al subir archivo');
      }
    } catch (error) {
      setMessage('Error al subir archivo');
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <div className='adminelement'>
      <h2>Subir usuarios finales</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor='clientes-finales'>Cliente: </label>
          <select
            id='clientes-finales'
            value={selectedClient}
            onChange={(event) => setSelectedClient(event.target.value)}
            required
          >
            <option value=''>Seleccione un cliente</option>
            {clients.map((client) => (
              <option key={client.id} value={client.id}>
                {client.nombre}
              </option>
            ))}
          </select>
        </div>

        <div style={{ marginTop: '10px' }}>
          <label htmlFor='archivo-usuarios-finales'>Archivo Excel: </label>
          <input
            id='archivo-usuarios-finales'
            type='file'
            accept='.xlsx,.xls'
            onChange={(event) => setExcelFile(event.target.files?.[0] || null)}
            required
          />
        </div>

        <button type='submit' disabled={isUploading} style={{ marginTop: '10px' }}>
          {isUploading ? 'Procesando...' : 'Subir usuarios finales'}
        </button>
      </form>

      {message && <p style={{ marginTop: '10px' }}>{message}</p>}
    </div>
  );
}

export default SubirUsuariosFinales;
